import { Tag, Icon, Popover } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  id: -1,
  name: '',
  type: '',
  closable: false,
  onClose: null,
  restriction: false,
  fieldDeleted: false,
};
const propTypes = {
  id: PropTypes.number,
  name: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
  type: PropTypes.string,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  restriction: PropTypes.bool,
  fieldDeleted: PropTypes.bool,
};

const ColumnTag = ({
  id,
  name,
  type,
  closable,
  onClose,
  children,
  restriction,
  fieldDeleted
}) => (
  <Tag
    className={`${cx('columnTag')} truncate ${restriction || fieldDeleted ? 'type-warning' : ''}`}
    closable={closable}
    onClose={onClose}
  >
    {restriction &&
      <Popover content={<FormattedMessage id="global.errors.restrictedField" />} trigger="hover">
        <Icon className={cx('restriction')} type="warning" />
      </Popover>
    }
    {
      fieldDeleted &&
      <Popover content={<FormattedMessage id="global.errors.deletedField" />} trigger="hover">
        <Icon className={cx('restriction')} type="warning" />
      </Popover>
    }
    {children}
  </Tag>
);

ColumnTag.defaultProps = defaultProps;
ColumnTag.propTypes = propTypes;
export default ColumnTag;



// WEBPACK FOOTER //
// ./src/components/ui/DragSources/ColumnTag.jsx